import { Icon } from '@chakra-ui/react';

export const ExpandIcon = (props) => <Icon viewBox='0 0 64 64' {...props}>
    <path d="M27.707,17.879a1,1,0,0,0-1.414,0l-1.414,1.414a1,1,0,0,0,0,1.414L36.172,32,24.879,43.293a1,1,0,0,0,0,1.414l1.414,1.414a1,1,0,0,0,1.414,0L41.121,32.707a1,1,0,0,0,0-1.414Z"></path>
</Icon>